import { Lock, Undo2 } from "lucide-react";

const ACTION_TYPES = [
    { value: "block", label: "Block Service" },
    { value: "warn", label: "Show Warning" },
    { value: "proceed", label: "Continue" },
];

const ACTION_STYLES = {
    block: "bg-red-100 text-red-700 border-red-200",
    warn: "bg-yellow-100 text-yellow-700 border-yellow-200",
    proceed: "bg-green-100 text-green-700 border-green-200",
};

const EligibilityRequiredQuestions = ({
    questions,
    handleOptionChange,
    saving,
    viewMode,
}) => {

    return (

        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">

            <div className="flex items-center justify-between mb-5">

                <div className="font-semibold">
                    Required Rules
                </div>

                {saving && (
                    <div className="text-xs text-gray-500">
                        Saving...
                    </div>
                )}

            </div>

            {questions.map((question, questionIndex) => (

                <div
                    key={question._id || questionIndex}
                    className="mb-6"
                >

                    <div className="text-sm font-medium mb-3">
                        {question.question}
                    </div>

                    {(question.options || []).map((option, optionIndex) => {

                        const originalOption = (question.options_org_adult_full || [])
                            .find(original => original._id === option._id);

                        const isChanged =
                            originalOption &&
                            option.type !== originalOption.type;

                        return (

                        <div
                            key={option._id || optionIndex}
                            className="mb-2"
                        >
                            <div
                                className={`flex items-center justify-between border rounded-lg px-4 py-3 ${
                                    isChanged ? "border-red-200" : ""
                                }`}
                            >

                            {/* <span className="text-sm">
                                {option.label}
                            </span> */ }

                            <span
                                className={`text-sm ${
                                    isChanged ? "text-red-600 font-medium" : ""
                                }`}
                            >
                                {option.label}
                            </span>

                            <div className="flex items-center gap-2">

                                {!viewMode && isChanged && (
                                    <button
                                        type="button"
                                        onClick={() =>
                                            handleOptionChange(
                                                questionIndex,
                                                optionIndex,
                                                originalOption.type
                                            )
                                        }
                                        title="Reset to default"
                                        className="text-gray-400 hover:text-gray-700 p-1 rounded transition-colors"
                                    >
                                        <Undo2 size={15} />
                                    </button>
                                )}

                                <select

                                    value={option.type}

                                    onChange={(e) =>
                                        handleOptionChange(
                                            questionIndex,
                                            optionIndex,
                                            e.target.value
                                        )
                                    }

                                    className={`border rounded-full px-3 py-1 text-sm font-medium ${ACTION_STYLES[option.type]}`}

                                >

                                    {ACTION_TYPES.map(action => (

                                        <option
                                            key={action.value}
                                            value={action.value}
                                        >
                                            {action.label}
                                        </option>

                                    ))}

                                </select>

                                {!question.customQuestion && (

                                    <Lock
                                        size={14}
                                        className="text-gray-400"
                                    />

                                )}

                            </div>
                            </div>

                            {isChanged && !viewMode && (
                                <div className="text-xs text-red-600 mt-1 px-4">
                                    You’re changing the default screening outcome. This may
                                    allow a client to proceed under different conditions than
                                    originally configured.
                                </div>
                            )}

                            

                        </div>
                        );
                    })}

                </div>

            ))}

        </div>

    );

};

export default EligibilityRequiredQuestions;